export const FOOTER_MENU = [
  {
    menuName: 'Terms of Use',
    link: 'https://www.principal.com/terms-of-use',
    isEmailFooter: true,
    active: true,
  },
  {
    menuName: 'Disclosures',
    link: 'https://www.principal.com/products-services-disclosures',
    isEmailFooter: true,
    active: true,
  },
  {
    menuName: 'Privacy',
    link: 'https://www.principal.com/privacy-policies',
    isEmailFooter: true,
    active: true,
  },
  {
    menuName: 'Security',
    link: 'https://www.principal.com/security-policies',
    isEmailFooter: true,
    active: true,
  },
  {
    menuName: 'Report Fraud',
    link: 'https://www.principal.com/about-us/our-company/policies/report-fraud-or-unethical-conduct',
    isEmailFooter: true,
    active: true,
  },
];
